import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Calendar, Tag } from "lucide-react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

export default function BlogPage() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/api/blog`).then((r) => setArticles(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen pt-24 pb-16" data-testid="blog-page">
      {/* Hero */}
      <section className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 mb-16">
        <div className="max-w-3xl">
          <p className="text-xs font-bold tracking-[0.3em] uppercase text-[#FF5200] mb-4 font-heading">Blog</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-heading font-black uppercase leading-[0.9] tracking-tight text-[#09090B] mb-6">
            News e Guide<br />
            <span className="text-[#FF5200]">Trasporti</span>
          </h1>
          <p className="text-base md:text-lg text-zinc-600 font-body leading-relaxed max-w-xl">
            Guide pratiche, consigli e novita dal mondo dei trasporti, della logistica e delle spedizioni merci in Italia.
          </p>
        </div>
      </section>

      {/* Articles Grid */}
      <section className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
        {loading ? (
          <div className="text-center py-20">
            <div className="w-8 h-8 border-2 border-[#FF5200] border-t-transparent rounded-full animate-spin mx-auto" />
          </div>
        ) : articles.length === 0 ? (
          <p className="text-zinc-500 text-center py-20 font-body">Nessun articolo pubblicato.</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {articles.map((a) => (
              <Link
                key={a.id}
                to={`/blog/${a.slug}`}
                className="group border border-zinc-200 bg-white hover:border-[#FF5200] transition-colors duration-300"
                data-testid={`blog-card-${a.slug}`}
              >
                {a.image_url && (
                  <div className="aspect-video bg-zinc-100 overflow-hidden">
                    <img src={a.image_url} alt={a.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  </div>
                )}
                <div className="p-6">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="text-[10px] font-bold tracking-widest uppercase bg-[#FF5200]/10 text-[#FF5200] px-2 py-1 font-heading">
                      {a.category}
                    </span>
                    <span className="flex items-center gap-1 text-xs text-zinc-400">
                      <Calendar size={10} />
                      {new Date(a.published_at).toLocaleDateString("it-IT")}
                    </span>
                  </div>
                  <h2 className="font-heading font-bold text-lg uppercase leading-tight text-[#09090B] mb-3 group-hover:text-[#FF5200] transition-colors">
                    {a.title}
                  </h2>
                  <p className="text-sm text-zinc-600 font-body leading-relaxed line-clamp-3 mb-4">
                    {a.excerpt}
                  </p>
                  <span className="inline-flex items-center gap-2 text-xs font-bold tracking-widest uppercase text-[#FF5200] font-heading group-hover:gap-3 transition-all">
                    Leggi <ArrowRight size={14} />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>

      {/* City Pages Section */}
      <section className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 mt-24">
        <div className="border-t border-zinc-200 pt-16">
          <h2 className="font-heading font-bold text-base md:text-lg uppercase tracking-wide text-[#09090B] mb-8">
            Trasporti per citta
          </h2>
          <div className="flex flex-wrap gap-3">
            {["Milano", "Brescia", "Verona", "Bergamo", "Mantova", "Padova", "Vicenza", "Roma", "Torino", "Bologna", "Firenze", "Napoli"].map((city) => (
              <Link
                key={city}
                to={`/trasporti/${city.toLowerCase()}`}
                className="px-4 py-2 border border-zinc-200 text-sm font-body text-zinc-600 hover:border-[#FF5200] hover:text-[#FF5200] transition-colors"
                data-testid={`city-link-${city.toLowerCase()}`}
              >
                Trasporti {city}
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
